import {

  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAIL,

  ALL_ORDERS_REQUEST,
  ALL_ORDERS_SUCCESS,
  ALL_ORDERS_FAIL,

  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAIL,

  CREATE_REPORT_REQUEST,
  CREATE_REPORT_SUCCESS,
  CREATE_REPORT_FAIL,


  ORDER_REPORTS_REQUEST,
  ORDER_REPORTS_SUCCESS,
  ORDER_REPORTS_FAIL,


  UPDATE_REPORT_STATUS_REQUEST,
  UPDATE_REPORT_STATUS_SUCCESS,
  UPDATE_REPORT_STATUS_FAIL,

  CHART_DATA_REQUEST,
  CHART_DATA_SUCCESS,
  CHART_DATA_FAIL,


  CREATE_REMARKS_REQUEST,
  CREATE_REMARKS_SUCCESS,
  CREATE_REMARKS_FAIL,

} from "../constants/orderConstants";
import api from "../../api";


export const createOrderAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });



    const { data } = await api.post(`/api/v1/order/create`, orderData);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const markReviewedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });


    const { data } = await api.post(`/api/v1/order/mark-reviewed`, orderData);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const holdOrderAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/mark-on-hold`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const markAsDeliveredAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/mark-as-delivered`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const allowEditingAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/allow-editing`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const orderRefundedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });



    const { data } = await api.post(`/api/v1/order/order-refunded`, orderData);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const reviewDeletedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });



    const { data } = await api.post(`/api/v1/order/review-deleted`, orderData);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};


export const confirmRefundAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/confirm-refund`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const markAsCompletedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });
    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await api.post(`/api/v1/order/mark-as-completed`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const markAsCommissionedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/mark-as-commissioned`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const multiMarkAsCommissionedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/multi-mark-as-commissioned`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const multiMarkAsCompletedAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/multi-mark-as-completed`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const cancelOrderAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/cancel`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const cancelOrderByPMMAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await api.post(`/api/v1/order/cancel-by-pmm`, orderData, config);
    dispatch({ type: CREATE_ORDER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_ORDER_FAIL, payload: error.response.data.message });
  }
};

export const cancelOrderByAdminAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await api.post(`/api/v1/order/cancel-by-admin`, orderData, config);
    dispatch({ type: CREATE_ORDER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_ORDER_FAIL, payload: error.response.data.message });
  }
};

export const refundedPendingReviewAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await api.post(`/api/v1/order/refunded-pending-review`, orderData, config);
    dispatch({ type: CREATE_ORDER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_ORDER_FAIL, payload: error.response.data.message });
  }
};
export const releaseOrderAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/release-order`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const updateOrderStatusAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/update-status`, orderData, config);

    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const OrderDetailsAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_DETAILS_REQUEST });


    const { data } = await api.get(`/api/v1/order/orders-details?order_id=${id}`);

    dispatch({
      type: ORDER_DETAILS_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const chartDataAction = (dateFrom,dateTo) => async (dispatch) => {
  try {
    dispatch({ type: CHART_DATA_REQUEST });


    const { data } = await api.get(`/api/v1/order/chart?dateFrom=${dateFrom}&dateTo=${dateTo}`);

    dispatch({
      type: CHART_DATA_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CHART_DATA_FAIL,
      payload: error.response.data.message,
    });
  }
};


export const allOrdersAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: ALL_ORDERS_REQUEST })

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/order/all-orders?${queryString}` : `/api/v1/order/all-orders`;

    const { data } = await api.get(url);
    dispatch({
      type: ALL_ORDERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ALL_ORDERS_FAIL,
      payload: error.response.data.message,
    })
  }
}



export const delayedRefundOrdersAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: ALL_ORDERS_REQUEST })

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/order/delayed-refunds?${queryString}` : `/api/v1/order/delayed-refunds`;

    const { data } = await api.get(url);
    dispatch({
      type: ALL_ORDERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ALL_ORDERS_FAIL,
      payload: error.response.data.message,
    })
  }
}




export const createReportAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_REPORT_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/create-report`, orderData, config);

    dispatch({
      type: CREATE_REPORT_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_REPORT_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const createRemarksAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_REMARKS_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/create-remarks`, orderData, config);

    dispatch({
      type: CREATE_REMARKS_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: CREATE_REMARKS_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const updateReportStatusAction = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_REPORT_STATUS_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };


    const { data } = await api.post(`/api/v1/order/update-report-status`, orderData, config);

    dispatch({
      type: UPDATE_REPORT_STATUS_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: UPDATE_REPORT_STATUS_FAIL,
      payload: error.response.data.message,
    });
  }
};


export const orderReportsAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_REPORTS_REQUEST })

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/order/all-reports?${queryString}` : `/api/v1/order/all-reports`;

    const { data } = await api.get(url);
    dispatch({
      type: ORDER_REPORTS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ORDER_REPORTS_FAIL,
      payload: error.response.data.message,
    })
  }
}



// actions/orderActions.js
export const exportOrdersExcelAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: "EXPORT_ORDERS_REQUEST" });

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/order/export-orders?${queryString}` : `/api/v1/order/export-orders`;

    const response = await api.get(url, { responseType: "blob" });

    // Download file
    const blob = new Blob([response.data], { type: response.data.type });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `orders_${Date.now()}.xlsx`;
    link.click();

    dispatch({ type: "EXPORT_ORDERS_SUCCESS" });
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const reader = new FileReader();

      reader.onload = () => {
        try {
          const err = JSON.parse(reader.result);
          dispatch({
            type: "EXPORT_ORDERS_FAIL",
            payload: err.message || "Something went wrong",
          });
        } catch {
          dispatch({
            type: "EXPORT_ORDERS_FAIL",
            payload: "Error parsing server response",
          });
        }
      };

      reader.readAsText(error.response.data);
    } else {
      dispatch({
        type: "EXPORT_ORDERS_FAIL",
        payload: error.response?.data?.message || error.message,
      });
    }
  }
};